import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { CommonTypes } from "./types";
import { parseAndConvertDates } from "@dp/common";
import { UIError } from "./errors";

var Check = /*#__PURE__*/function () {
  function Check(config, axios) {
    _classCallCheck(this, Check);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Check, [{
    key: "getMobilePayAppInitData",
    value: function () {
      var _getMobilePayAppInitData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var jwtToken,
            commonQueryParams,
            locale,
            headers,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                jwtToken = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                return _context.abrupt("return", this.axios.get(this.config.postfix.MOBILE_PAY_APP_INIT, {
                  params: {
                    locale: locale
                  },
                  headers: headers
                }).then(function (response) {
                  return response.data.response;
                })["catch"](function (error) {
                  throw new UIError(error);
                }));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMobilePayAppInitData() {
        return _getMobilePayAppInitData.apply(this, arguments);
      }

      return getMobilePayAppInitData;
    }()
  }, {
    key: "getCheckDetails",
    value: function () {
      var _getCheckDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        var jwtToken,
            payload,
            commonQueryParams,
            locale,
            headers,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                jwtToken = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;
                payload = _args2.length > 1 ? _args2[1] : undefined;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                return _context2.abrupt("return", this.axios.get(this.config.postfix.MOBILE_PAY_CHECK_API, {
                  params: _objectSpread({
                    locale: locale
                  }, payload),
                  headers: headers
                }).then(function (response) {
                  return _this.parseAndAdjustCheckResponse(response.data.response);
                })["catch"](function (error) {
                  throw new UIError(error);
                }));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getCheckDetails() {
        return _getCheckDetails.apply(this, arguments);
      }

      return getCheckDetails;
    }() // Temporary fix to add tax to tippableAmount for web.
    // This will be removed once the backend starts giving tippable amount
    // as (subTotal + tax). Currently tippableAmount is equal to subTotal
    // for the web api.

  }, {
    key: "_adjustTippableAmountForMobilePay",
    value: function _adjustTippableAmountForMobilePay(data) {
      var _order$tippableAmount, _order$taxAmount;

      var order = data.order;
      order.tippableAmount.value = (order === null || order === void 0 ? void 0 : (_order$tippableAmount = order.tippableAmount) === null || _order$tippableAmount === void 0 ? void 0 : _order$tippableAmount.value) + (order === null || order === void 0 ? void 0 : (_order$taxAmount = order.taxAmount) === null || _order$taxAmount === void 0 ? void 0 : _order$taxAmount.value);
      return data;
    }
  }, {
    key: "getCheckSummary",
    value: function () {
      var _getCheckSummary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(tkn) {
        var _response$data;

        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.axios.get(this.config.postfix.CURBSIDE_CHECK_SUMMARY_API, {
                  params: {
                    tkn: tkn
                  }
                });

              case 2:
                response = _context3.sent;

                if (!((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.orderSummary) === "true")) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return");

              case 7:
                throw response;

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getCheckSummary(_x) {
        return _getCheckSummary.apply(this, arguments);
      }

      return getCheckSummary;
    }()
  }, {
    key: "applyCoupon",
    value: function () {
      var _applyCoupon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(paymentCode, couponCode, jwtToken) {
        var _this2 = this;

        var commonQueryParams, conceptCode, locale, headers;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                conceptCode = this.config.getConceptCode();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                return _context4.abrupt("return", this.axios.put(this.config.postfix.MOBILE_PAY_APPLY_COUPON_API, {
                  paymentCode: paymentCode,
                  couponCode: couponCode
                }, {
                  params: {
                    locale: locale,
                    conceptCode: conceptCode
                  },
                  headers: headers
                }).then(function (response) {
                  return _this2._adjustTippableAmountForMobilePay(parseAndConvertDates(response.data.response));
                })["catch"](function (error) {
                  throw new UIError(error);
                }));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function applyCoupon(_x2, _x3, _x4) {
        return _applyCoupon.apply(this, arguments);
      }

      return applyCoupon;
    }()
  }, {
    key: "removeCoupon",
    value: function () {
      var _removeCoupon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(paymentCode, jwtToken, couponCode) {
        var _this3 = this;

        var commonQueryParams, conceptCode, locale, headers;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                conceptCode = this.config.getConceptCode();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                return _context5.abrupt("return", this.axios.put(this.config.postfix.MOBILE_PAY_REMOVE_COUPON_API, {
                  paymentCode: paymentCode,
                  couponCode: couponCode
                }, {
                  params: {
                    locale: locale,
                    conceptCode: conceptCode
                  },
                  headers: headers
                }).then(function (response) {
                  return _this3._adjustTippableAmountForMobilePay(parseAndConvertDates(response.data.response));
                })["catch"](function (error) {
                  throw new UIError(error);
                }));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function removeCoupon(_x5, _x6, _x7) {
        return _removeCoupon.apply(this, arguments);
      }

      return removeCoupon;
    }()
  }, {
    key: "sendEmailConfirmation",
    value: function () {
      var _sendEmailConfirmation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(email, paymentCode) {
        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.axios.post(this.config.postfix.MOBILE_PAY_SEND_EMAIL_CONFIRMATION, {
                  email: email,
                  paymentCode: paymentCode
                });

              case 2:
                response = _context6.sent;

                if (!(response.statusMessage === "Success")) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return");

              case 7:
                throw response;

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function sendEmailConfirmation(_x8, _x9) {
        return _sendEmailConfirmation.apply(this, arguments);
      }

      return sendEmailConfirmation;
    }()
  }, {
    key: "payCheck",
    value: function () {
      var _payCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload) {
        var _this4 = this;

        var jwtToken,
            commonQueryParams,
            locale,
            headers,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                jwtToken = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : null;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                return _context7.abrupt("return", this.axios.post(this.config.postfix.MOBILE_PAY_PAYMENT_API, payload, {
                  params: {
                    locale: locale
                  },
                  headers: headers
                }).then(function (response) {
                  return _this4.parseAndAdjustCheckResponse(response.data.response);
                })["catch"](function (error) {
                  throw new UIError(error);
                }));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function payCheck(_x10) {
        return _payCheck.apply(this, arguments);
      }

      return payCheck;
    }()
  }, {
    key: "parseAndAdjustCheckResponse",
    value: function parseAndAdjustCheckResponse(data) {
      return this._adjustTippableAmountForMobilePay(parseAndConvertDates(data));
    }
  }]);

  return Check;
}();

export { Check as default };